import { axiosApiInstance } from "./HttpService";
import { ITransactionWebModelRequest } from "../requests/ITransactionWebModelRequest";
import { AxiosRequestConfig, AxiosResponse } from "axios";
import { ISenderProfileWebModelRequest } from "../requests/ISenderProfileWebModelRequest";
import Swal from "sweetalert2";
import i18next from "i18next";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import { toast } from "react-toastify";

export class TransactionService {
  public static async getAllForDashboard(request: ITransactionWebModelRequest) {
    let dataURL: string = `${process.env.REACT_APP_API_URL}/api/Transaction/TransactionsForDashboard`;
    return await axiosApiInstance.post(dataURL, request);
  }
  public static async getAll(request: ITransactionWebModelRequest) {
    let dataURL: string = `${process.env.REACT_APP_API_URL}/api/Transaction/Transactions`;
    return await axiosApiInstance.post(dataURL, request);
  }
  public static async getAllMinoristTransactions(
    request: ITransactionWebModelRequest
  ) {
    let dataURL: string = `${process.env.REACT_APP_API_URL}/api/Transaction/TransactionsFromMin`;
    return await axiosApiInstance.post(dataURL, request);
  }
  public static async onboardMinoristMerchants() {
    let dataURL: string = `${process.env.REACT_APP_API_URL}/api/viewerOnboarding/onboardMinMerchants`;
    return await axiosApiInstance.post(dataURL);
  }

  public static async getCurrentTransactions(
    request: ITransactionWebModelRequest
  ) {
    let dataURL: string = `${process.env.REACT_APP_API_URL}/api/Transaction/CurrentTransactions`;
    return await axiosApiInstance.post(dataURL, request);
  }

  public static async getQrTransactionsAll(
    request: ITransactionWebModelRequest
  ) {
    let dataURL: string = `${process.env.REACT_APP_API_URL}/api/Transaction/qrTransactions`;
    return await axiosApiInstance.post(dataURL, request);
  }

  public static getFeatures() {
    let dataURL: string = `${process.env.REACT_APP_API_URL}/api/Features/getFeatures`;
    return axiosApiInstance.post(dataURL, {});
  }

  public static async getAllIssuers() {
    let dataURL: string = `${process.env.REACT_APP_API_URL}/api/Transaction/GetAllIssuers`;
    return await axiosApiInstance.get(dataURL);
  }

  public static async getAllToExcel(request: ITransactionWebModelRequest) {
    //toast.info("El excel se descargará cuando esté listo");
    let dataURL: string = `${process.env.REACT_APP_API_TRXSENDER_URL}/apiTrxSender/FileExporter/generateExcel`;
    let options: AxiosRequestConfig = {
      responseType: "blob", // don't forget this
    };

    return await axiosApiInstance.post(dataURL, request, options);
  }
  public static async getAllToExcelFromMin(
    request: ITransactionWebModelRequest
  ) {
    let dataURL: string = `${process.env.REACT_APP_API_TRXSENDER_URL}/apiTrxSender/FileExporter/generateExcelFromMin`;
    let options: AxiosRequestConfig = {
      responseType: "blob", // don't forget this
    };

    return await axiosApiInstance.post(dataURL, request, options);
  }

  public static async getTicket(
    transactionID: string,
    transactionType: string
  ) {
    let dataURL: string =
      `${process.env.REACT_APP_API_URL}/api/Transaction/Ticket` +
      transactionID +
      "/" +
      transactionType;
    return await axiosApiInstance.get(dataURL);
  }

  public static async getLinkAutomaticDebit() {
    let dataURL: string = `${process.env.REACT_APP_API_URL}/api/Transaction/GetUrlAutomaticDebit`;
    return await axiosApiInstance.get(dataURL);
  }

  public static async getTotalsByIssuerAndCurrency(transactionID: string) {
    let dataURL: string =
      `${process.env.REACT_APP_API_URL}/api/Transaction/TotalsByIssuerAndCurrency` +
      transactionID;
    return await axiosApiInstance.get(dataURL);
  }

  static getTransactionStatusByTerminal(terminals: string[]) {
    let dataURL: string = `${process.env.REACT_APP_API_URL}/api/Transaction/getTransactionStatusByTerminal`;
    return axiosApiInstance.post(dataURL, { terminals: terminals });
  }

  public static showTicket(tranId: string, transactionType: string) {
    TransactionService.getTicket(tranId, transactionType)
      .then((response: AxiosResponse<string>) => {
        //Swal.fire(tranId, response.data);
        Swal.fire({
          // title: "Detalle de la transacción",
          html: response.data,
          showCloseButton: true,
          confirmButtonColor: "#f60",
          confirmButtonText: `
                        <span style="display: flex; align-items: center; gap: 6px;">
                            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="15" viewBox="0 0 14 15" fill="none">
                                <path d="M11.9997 9.94157V12.4416H1.99967V9.94157H0.333008V12.4416C0.333008 13.3582 1.08301 14.1082 1.99967 14.1082H11.9997C12.9163 14.1082 13.6663 13.3582 13.6663 12.4416V9.94157H11.9997ZM11.1663 6.60824L9.99134 5.43324L7.83301 7.58324V0.774902H6.16634V7.58324L4.00801 5.43324L2.83301 6.60824L6.99967 10.7749L11.1663 6.60824Z" fill="white"/>
                            </svg>
                            Descargar PDF
                        </span>
                    `,
            customClass: {
                container: "transaction-container-class",
            },
            }).then((result: any) => {
            if (result.isConfirmed) {

            const voucher = document.getElementsByClassName("container-voucher")[0] as HTMLElement | undefined;
            const lote = document.getElementsByClassName("contain")[0] as HTMLElement | undefined;

            if(voucher){          
                const children = voucher.querySelectorAll("*");
                children.forEach((el) => {
                    const element = el as HTMLElement;
                    element.style.lineHeight = "1.8";
                    element.style.letterSpacing = "4px";
                    element.style.fontFamily = "Courier New, monospace";
                    if(element.className === "amount"){
                        element.style.fontSize = "20px";    
                        element.style.letterSpacing = "8px";
                        element.style.margin= "7px";
                    }else if(element.className === "issuer"){
                        element.style.fontSize = "7px";
                    }else if (element.className === "card-info"){
                        element.style.letterSpacing = ".3px";
                        element.style.fontSize = "6px";
                    }
                    else{
                        element.style.fontSize = "8px";
                    }
                });

                html2canvas(voucher, { scale: 2 }).then((canvas) => {

                    const imgData = canvas.toDataURL("image/png");
                    const pdf = new jsPDF({
                    orientation: "portrait",
                    unit: "px",
                    format: "a4",
                    });

                    const pageWidth = pdf.internal.pageSize.getWidth();
                    const pageHeight = (pdf.internal.pageSize.getHeight()-(pdf.internal.pageSize.getHeight() / 3));

                    const imgWidth = canvas.width;
                    const imgHeight = canvas.height;

                    const ratio = Math.min(pageWidth / imgWidth, pageHeight / imgHeight);
                    const imgX = (pageWidth - imgWidth * ratio) / 2;
                    const imgY = 20;

                    pdf.addImage(imgData, "PNG", imgX, imgY, imgWidth * ratio, imgHeight * ratio);
                    pdf.save(`Voucher-${tranId}.pdf`);
                });
            }else if(lote){

                if (lote != null) {
                    lote.style.fontFamily = "monospace";
                    let contain: HTMLElement | null = null;
                    // @ts-ignore
                    contain = lote.getElementsByClassName("contain")[0];

                    const doc = new jsPDF({
                            orientation: "portrait",
                        unit: "px",
                        format: "a4",
                    });
                    
                    const pageWidth = doc.internal.pageSize.getWidth();
                    const margin = 20; // margen lateral
                    const contentWidth = pageWidth - margin * 2;
                    const children = lote.querySelectorAll("*");
                    children.forEach((el) => {
                        const element = el as HTMLElement;
                        element.style.fontSize = "8px";
                    });
                    if (contain != null) {
                        // @ts-ignore
                        contain.style.width = `${contentWidth}px`;
                        contain.style.margin = "0px";
                        contain.style.padding= "0px";
                        contain.style.fontSize = "6px";
                    }

                    doc.html(lote, {
                    margin: [0, margin], // margen superior/inferior y lateral
                    width: contentWidth,
                    x: margin,
                    y: 0,
                    autoPaging: "slice",             
                    html2canvas: {
                        scale: 0.7, // achica contenido
                    },
                    async callback(doc) {
                        await doc.save("Voucher-" + tranId + ".pdf");
                    },
                    });
                }
                return true;
            }
        } else if (result.isDenied) {
            }
            });
        })
        .catch((error) => console.log("error:", error));
    }

    static buildTotalDetail(
        object: any,
        title: string,
        currencySymbol: string,
        accumulateTotal: boolean
    ): { title: string; total: string; data: { prop: string; value: string }[] } {
        var rowDetail: { prop: string; value: string }[] = [];
        var total = 0;
        for (var i in object) {
        rowDetail.push({
            prop: i,
            value: Intl.NumberFormat("es-UY", {
            style: "currency",
            currency: currencySymbol,
            }).format(Number(object[i] + "")),
        });
        total += Number(object[i] + "");
        }
        return {
        title: title,
        data: rowDetail,
        total: accumulateTotal
            ? Intl.NumberFormat("es-UY", {
                style: "currency",
                currency: currencySymbol,
            }).format(total)
            : "",
        };
    }

    static generateQR(fiscalDocument: string) {
        let dataURL: string = `${process.env.REACT_APP_API_URL}/api/QrViewer/getQr`;
        return axiosApiInstance.post(dataURL, {
        fiscalDocument: fiscalDocument,
        });
    }
}
